import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2d2505fc = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _a1ff9560 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _965339e0 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _893f800a = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _25efd692 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _36f0b120 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _14f7442c = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _15c06520 = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _744c529c = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _75d0d430 = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _3dbf54c6 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _0a0da25d = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _4b0d7608 = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _5ae3b21f = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _c6c53680 = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _7cc411b5 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _5d9c5536 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _4909b240 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _c5fccc26 = () => interopDefault(import('../../../pages/app/pano-report/index.vue' /* webpackChunkName: "" */))
const _6b909b75 = () => interopDefault(import('../../../pages/app/result/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _2d2505fc,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _a1ff9560,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _965339e0,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _893f800a,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _25efd692,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _36f0b120,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _36f0b120,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _36f0b120,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _14f7442c,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _15c06520,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _744c529c,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _15c06520,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _744c529c,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _75d0d430,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _75d0d430,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _75d0d430,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _75d0d430,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _75d0d430,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _75d0d430,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _75d0d430,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _3dbf54c6,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _3dbf54c6,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _0a0da25d,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _4b0d7608,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _4b0d7608,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _5ae3b21f,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _c6c53680,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _7cc411b5,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _7cc411b5,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _5d9c5536,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _4909b240,
    name: "appDownload"
  }, {
    path: "/esfcommon/app/pano-report",
    component: _c5fccc26,
    name: "panoReport"
  }, {
    path: "/esfcommon/app/result",
    component: _6b909b75,
    name: "panoReportResult"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
